import type { IResource } from "@gettactic/api";

/**
 * True when the resource may only be booked through a workplace request.
 *
 * `ticket_type_ids` is `omitempty` and only ever hydrated by the `/v1/resources*`
 * endpoints, so an absent field reads as "not gated" — callers holding a resource
 * from the legacy office listing will always get `false` here.
 */
export const isResourceTicketGated = (
  resource:
    | Pick<IResource, "is_approvable" | "ticket_type_ids">
    | null
    | undefined
): boolean =>
  !!resource?.is_approvable && (resource.ticket_type_ids?.length ?? 0) > 0;
